import React from "react";
import './style.scss';


export default function NotFound()  {
  return <div>Not Found</div>;
}